import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import type {BaseUrlsStrategyData} from '../../types/base-urls-data.type';
import {BaseUrlsStrategyService} from '../../BasePathStrategyService';


@Service({id: 'baseUrlsFallbackStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<BaseUrlsStrategyService> {

  build(details: BaseUrlsStrategyData): BaseUrlsStrategyService {
      return new BaseUrlFallbackStrategyService(details);
  }
}

export class BaseUrlFallbackStrategyService extends BaseUrlsStrategyService{
  details: BaseUrlsStrategyData;

  constructor(details: BaseUrlsStrategyData) {
      super();
      this.details = details;
  }
  getBaseUrls(): any {//eslint-disable-line @typescript-eslint/no-explicit-any
      return {};
  }
}
